import {FormControl, FormGroup} from "@angular/forms";
import {addressModelFactory} from "../../address/address.model";
import {contactModelFactory} from "../../contact/contact.model";

export class DeliveryOpsInformationModel extends FormGroup {
  constructor() {
    super({
      csa: new FormControl(),
      ampId: new FormControl(),
      msId: new FormControl(),
      handoverIdNumber: new FormControl(),
      customerErpNumber: new FormControl(),
      opgNumber: new FormControl(),
      orderAcceptance: new FormControl(),
      earlyOrderRec: new FormControl(),
      multiYear: new FormControl(),
      multiYearPoType: new FormControl(),
      multiYearTerm: new FormControl(),
      multiYearTermDuration: new FormControl(),
      plant: new FormControl(),
      prepaidFieldOnDorTab: new FormControl(),
      previousDocument: new FormControl(),
      renewal: new FormControl(),
      ruleDescription: new FormControl(),
      salesDocumentType: new FormControl(),
      legacyReportedDate: new FormControl(),
      legacyReportedDatePicker: new FormControl(),
      multiYearEndDate: new FormControl(),
      multiYearEndDatePicker: new FormControl(),
      multiYearStartDate: new FormControl(),
      multiYearStartDatePicker: new FormControl(),
      dorRelavant: new FormControl(),
      endCustomerSplit: new FormControl(),
      payerSplit: new FormControl(),
      poNumberSplit: new FormControl(),
      shipToSplit: new FormControl(),
      initialBillingDate: new FormControl(),
      billingStart: new FormControl(),
      billToAddressName1: new FormControl(),
      billToAddressName2: new FormControl(),
      billToAddressLine1: new FormControl(),
      billToAddressLine2: new FormControl(),
      billToAddressCity: new FormControl(),
      billToAddressRegion: new FormControl(""),
      billToAddressPostalCode: new FormControl(),
      billToAddressCountry: new FormControl(),
      billToContactFirstName: new FormControl(),
      billToContactLastName: new FormControl(),
      billToContactEmailAddress: new FormControl(),
      billToContactPhoneNumber: new FormControl(),
      billToContactPhoneNumber2: new FormControl(),
      billToContactLocale: new FormControl(),
      enableCatalogPricing: new FormControl(),
      enableBulkOrdering: new FormControl(),
      orderAcceptanceDisableReason: new FormControl(), // Only used upon a disable
      orderAcceptanceCompleteDate: new FormControl(),
      orderAcceptanceCompleteDatePicker: new FormControl(),
      currency: new FormControl(),
      customerBpId: new FormControl(),
      contractAccountId: new FormControl(),
      contractAccountCategory: new FormControl(),
      paymentTerms: new FormControl(),
      paymentMethod: new FormControl(),
      correspondenceVariant: new FormControl(),
      accountDeterminationId: new FormControl(),
      companyCodeGroup: new FormControl(),
      standardCompanyCode: new FormControl(),
      outgoingPaymentMethod: new FormControl(),
      invoiceScheduling: new FormControl(),
    });
  }

  public changeCountry(country) {
    this.controls["billToAddressCountry"].setValue(country || "");
  }

  public parseProjectJson(project?: any) {
    const address = addressModelFactory(project.address);
    const contact = contactModelFactory(project.billToContact);

    const values = {
      earlyOrderRec: project.earlyOrderRec || "",
      multiYear: project.multiYear || "",
      multiYearPoType: project.multiYearPoType || "",
      multiYearTerm: project.multiYearTerm || "",
      multiYearTermDuration: project.multiYearTermDuration || "",
      plant: project.plant || "",
      prepaidFieldOnDorTab: project.prepaidFieldOnDorTab || "",
      previousDocument: project.previousDocument || "",
      renewal: project.renewal || "",
      ruleDescription: project.ruleDescription || "",
      salesDocumentType: project.salesDocumentType || "",
      legacyReportedDate: project.legacyReportedDate || "",
      legacyReportedDatePicker: project.legacyReportedDatePicker || "",
      multiYearEndDate: project.multiYearEndDate || "",
      multiYearEndDatePicker: project.multiYearEndDatePicker || "",
      multiYearStartDate: project.multiYearStartDate || "",
      multiYearStartDatePicker: project.multiYearStartDatePicker || "",
      dorRelavant: project.dorRelavant === false ? false : (project.dorRelavant || ""),
      endCustomerSplit: project.endCustomerSplit === false ? false : (project.endCustomerSplit || ""),
      payerSplit: project.payerSplit === false ? false : (project.payerSplit || ""),
      poNumberSplit: project.poNumberSplit === false ? false : (project.poNumberSplit || ""),
      shipToSplit: project.shipToSplit === false ? false : (project.shipToSplit || ""),
      csa: project.csa || "",
      ampId: project.ampId || "",
      msId: project.msId || "",
      customerErpNumber: project.customerErpNumber || "",
      handoverIdNumber: project.handoverIdNumber || "",
      opgNumber: project.opgNumber || "",
      orderAcceptance: project.orderAcceptance === false ? false : (project.orderAcceptance || ""),
      enableCatalogPricing: project.enableCatalogPricing || false,
      enableBulkOrdering: project.enableBulkOrdering || false,
      initialBillingDate: project.initialBillingDate === false ? false : (project.initialBillingDate || ""),
      billingStart: project.billingStart,
      billToAddressName1: address.name1 || "",
      billToAddressName2: address.name2 || "",
      billToAddressLine1: address.line1 || "",
      billToAddressLine2: address.line2 || "",
      billToAddressCity: address.city || "",
      billToAddressRegion: address.region || "",
      billToAddressPostalCode: address.postalCode || "",
      billToAddressCountry: address.country || "",
      billToContactFirstName: contact.firstName || "",
      billToContactLastName: contact.lastName || "",
      billToContactEmailAddress: contact.emailAddress || "",
      billToContactPhoneNumber: contact.phoneNumber || "",
      billToContactPhoneNumber2: contact.phoneNumber2 || "",
      billToContactLocale: contact.locale || "",
      orderAcceptanceDisableReason: "",
      orderAcceptanceCompleteDate: project.orderAcceptanceCompleteDate || "",
      orderAcceptanceCompleteDatePicker: project.orderAcceptanceCompleteDate || "",
      currency: project.currency || "",
      customerBpId: project.customerBpId || "",
      contractAccountId: project.contractAccountId || "",
      contractAccountCategory: project.contractAccountCategory || "",
      paymentTerms: project.paymentTerms || "",
      paymentMethod: project.paymentMethod || "",
      correspondenceVariant: project.correspondenceVariant || "",
      accountDeterminationId: project.accountDeterminationId || "",
      companyCodeGroup: project.companyCodeGroup || "",
      standardCompanyCode: project.standardCompanyCode || "",
      outgoingPaymentMethod: project.outgoingPaymentMethod || "",
      invoiceScheduling: project.invoiceScheduling || "",
    };
    this.setValue(values);
  }

  public exportDeliveryOpsInformation(projectId) {
    const project = this.value;
    return {
      project: {id: projectId, ...project},
      billToAddress: {
        name1: project.billToAddressName1,
        name2: project.billToAddressName2,
        line1: project.billToAddressLine1,
        line2: project.billToAddressLine2,
        city: project.billToAddressCity,
        region: project.billToAddressRegion,
        postalCode: project.billToAddressPostalCode,
        country: project.billToAddressCountry,
        defaultLocale: project.billToContactLocale,
      },
      billToContact: {
        firstName: project.billToContactFirstName,
        lastName: project.billToContactLastName,
        emailAddress: project.billToContactEmailAddress,
        phoneNumber: project.billToContactPhoneNumber,
        phoneNumber2: project.billToContactPhoneNumber2,
        locale: project.billToContactLocale,
      },
    };
  }
}
